import { GraphQLID, GraphQLNonNull } from 'graphql'

export interface OrganizationArgs {
  organizationUuid: string
}

export const organizationArgs = {
  organizationUuid: {
    description: 'The unique ID for an organization',
    type: new GraphQLNonNull(GraphQLID)
  }
}

export interface OrganizationIdArgs {
  organizationID: string
}

export const organizationIdArgs = {
  organizationID: {
    description: 'The unique ID for an organization',
    type: new GraphQLNonNull(GraphQLID)
  }
}
